import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import CloseIcon from '@mui/icons-material/Close';

import { loadUser } from '../../../../../store/userService';
import StaticField from '../../../../formElements/StaticField';

import dropdown from '../../../../../commonStyles/rowExpand.module.css';
import local from '../../submissionStyles/iws.module.css';

const InWorkSupportDetails = ({ row, onClose }) => {
    const dispatch = useDispatch();

    // LOCAL STATE
    const [emailAddress, setEmailAddress] = useState('');

    // STORE STATE
    const users = useSelector((state) => state.entities.userService.users);

    // USE EFFECTS
    useEffect(() => {
        if (!row.contactedBy && row.contactedById) dispatch(loadUser(row.contactedById));
    }, [row]);

    useEffect(() => {
        if (!row.contactedById || row.contactedBy) return;
        const user = users.find((el) => el.id === row.contactedById);
        setEmailAddress(user?.loginEmailAddress || '');
    }, [users]);

    // RENDER
    return (
        <div className={`${dropdown.rowDropdown} ${dropdown.redBorder}`}>
            <div className={local.rowDetailWrapper}>
                <StaticField
                    id={'ownerId'}
                    label={'Contacted By'}
                    content={row.contactedBy || emailAddress || '-'}
                />
                <StaticField id={'notes'} label={'Notes'} content={row.note || '-'} />
            </div>

            <div className={dropdown.exit} onClick={onClose}>
                Close details
                <CloseIcon />
            </div>
        </div>
    );
};

InWorkSupportDetails.propTypes = {
    row: PropTypes.object,
    onClose: PropTypes.func.isRequired
};

export default InWorkSupportDetails;
